<template>
  <div class="search-bar">
    <transition
      name="slide-fade"
      mode="out-in"
    >
      <v-btn
        v-if="!expanded"
        icon
        @click="expandSearchBar(true)"
      >
        <v-icon>search</v-icon>
      </v-btn>

      <div
        v-else
        class="primary"
        :class="{ 'search-bar--full-width': $vuetify.breakpoint.xsOnly }"
      >
        <v-autocomplete
          id="global-search"
          v-model="selected"
          :loading="loading"
          :items="results"
          item-text="name"
          :search-input.sync="search"
          cache-items
          flat
          hide-no-data
          hide-details
          return-object
          :label="$t('search')"
          :autofocus="$vuetify.breakpoint.xsOnly"
          :prepend-inner-icon="$vuetify.breakpoint.mdAndUp ? 'search' : 'arrow_back'"
          solo-inverted
          @click:prepend-inner="collapseSearchBar"
          @input="onClickResult"
        >
          <template
            slot="item"
            slot-scope="{ item }"
          >
            <pa-user-avatar
              :image="item.image"
              :name="item.name"
              icon="work"
            />

            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </div>
    </transition>
  </div>
</template>

<script>
import { BSON } from 'mongodb-stitch-browser-sdk'

import { db } from '@/plugins/stitch'

export default {
  data () {
    return {
      expanded: this.$vuetify.breakpoint.mdAndUp,
      search: null,
      results: [],
      selected: null,
      loading: false
    }
  },
  watch: {
    search (val) {
      if (val && val !== this.selected) {
        this.execSearchDebounced(val)
      }
    }
  },
  methods: {
    async execSearch (term) {
      // this.results = await client
      //   .callFunction('search', [ term, this.$currentOrganization.id ])
      this.results = await db
        .collection('projects')
        .find({
          organization: this.$currentOrganization.id,
          name: new BSON.BSONRegExp(term, 'i')
        })
        .toArray()
    },
    execSearchDebounced () {
      clearTimeout(this._timerId)

      this._timerId = setTimeout(() => {
        this.execSearch()
      }, 400)
    },
    onClickResult () {
      if (!this.selected) return

      this.$router.push({ name: 'project-details', params: { name: this.selected._id.toString() } })
      this.clearAutocomplete()
    },
    clearAutocomplete () {
      document.getElementById('global-search').blur()
      this.$nextTick(() => {
        this.selected = null
      })
      this.collapseSearchBar()
    },
    expandSearchBar (expand) {
      // On md and up screens the search bar is not collapsible
      if (this.$vuetify.breakpoint.mdAndUp) { return }

      this.expanded = expand
    },
    collapseSearchBar () {
      this.expandSearchBar(false)
    }
  }
}
</script>

<style lang="scss">
.search-bar {
  z-index: 1;

  &--full-width {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
